"use client";

import { usePathname } from "next/navigation";
import { Suspense, useEffect, useState } from "react";

function Li() {
  const [name, setName] = useState("");
  const pathname = usePathname();
  const pathnames = pathname.split("/");

  useEffect(() => {
    const h2 = document.querySelector("h2");
    if (!h2) return;

    setName(h2.dataset.pop || "----");
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "attributes" && mutation.attributeName === "data-pop") {
          setName(h2.dataset.pop || "");
        }
      }
    });

    observer.observe(h2, {
      attributes: true,
      attributeFilter: ["data-pop"],
    });
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <li>{name}</li>
      {pathnames[4] === "player" && <li>選手一覧</li>}
      {pathnames[4] === "bats" && <li>打撃成績{pathnames[5] === "team" ? "（チーム）" : "（個人成績）"}</li>}
      {pathnames[4] === "pits" && <li>投手成績{pathnames[5] === "team" ? "（チーム）" : "（個人成績）"}</li>}
    </>
  );
}

export function LiTeam() {
  return (
    <Suspense fallback={<li>--------</li>}>
      <Li />
    </Suspense>
  );
}
